class PreCartItem extends Component {
    constructor(el) {
        super(el);
        this.image = this.$find('[data-image]');
        this.title = this.$find('[data-title]');
        this.variant = this.$find('[data-variant]');
        this.count = this.$find('[data-count]');
        this.price = this.$find('[data-price]');
        this.associatedProductsTitle = this.$find('[data-associated-products-title]');
        this.associatedProductsContainer = this.$find('[data-associated-products-container]');
        EventBus.getInstance().addEventListener('cartUpdated', e => this.onCartUpdated(e.detail));
    }

    onCartUpdated({preCart: data}) {
        this.image.innerHTML = data.product.image;
        this.title.innerText = data.product.title;
        this.variant.innerText = data.product.variant;
        this.count.innerText = data.product.count;
        this.price.innerHTML = data.product.price;

        this.associatedProductsContainer.innerHTML = ""; // Smažeme obsah containeru, pre-cart se recykluje
        const associatedProducts = data.associatedProducts;
        if (!associatedProducts || associatedProducts.length === 0) {
            this.associatedProductsTitle.classList.add("u-hiddenVisually");
            this.associatedProductsContainer.classList.add("u-hiddenVisually");
            return;
        }

        for (const associatedProduct of associatedProducts) {
            const associatedProductElement = document.createElement("div");
            const associatedProductTitleElement = document.createElement("div");
            const associatedProductCountElement = document.createElement("div");
            const associatedProductPriceElement = document.createElement("div");

            associatedProductElement.classList.add("PreCartItemAssociatedProduct");
            associatedProductTitleElement.classList.add("PreCartItemAssociatedProductTitle");
            associatedProductCountElement.classList.add("PreCartItemAssociatedProductCount");
            associatedProductPriceElement.classList.add("PreCartItemAssociatedProductPrice");

            associatedProductTitleElement.innerText = associatedProduct.title;
            associatedProductCountElement.innerText = associatedProduct.count;
            associatedProductPriceElement.innerHTML = associatedProduct.price;

            associatedProductElement.append(associatedProductTitleElement, associatedProductCountElement, associatedProductPriceElement);
            this.associatedProductsContainer.append(associatedProductElement);
        }

        // Nakonec sekci odkryjeme
        this.associatedProductsTitle.classList.remove("u-hiddenVisually");
        this.associatedProductsContainer.classList.remove("u-hiddenVisually");
    }
}
